export default function (Component) {
    Component.options.tsv = [{"label":"Panama Papers (2016)","value":11.5},{"label":"Paradise Papers (2017)","value":13.4},{"label":"Pandora Papers (2021)","value":11.9}]
  }